import { animate, query, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { OpendialogOfferDetailsComponent } from 'app/components/dialog/open-dialog-offer-details/opendialog-offer-details.component';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { ImgOfferDefaultService } from 'app/shared/services/img-offer-default/img-offer-default.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-admin-offers',
  templateUrl: './admin-offers.component.html',
  styleUrls: ['./admin-offers.component.scss'],
  animations: [
    trigger('change', [
      transition(':enter', [
        query('.wrap', [
          style({ opacity: 0, transform: 'translate(200px)' }),
          animate('.17s', style({ opacity: 1, transform: 'none' })),
        ])
      ]),
    ])]
})

export class AdminOffersComponent extends SubscriptionBaseComponent implements OnInit {
  searchForm: UntypedFormGroup;
  userConnected: any;
  valueInput: string;
  isLoading = false;
  isCreationMode = false;
  isSessionMode = false;
  isFileMode = false;
  offers: FullOffer[] = [];
  offerToEdit: FullOffer;
  offerPreview: FullOffer;
  imageUpdate: string;

  constructor(
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private formBuilder: UntypedFormBuilder,
    private imgOfferDefault: ImgOfferDefaultService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private tooltip: TooltipService,
    private offerService: OfferService,
    private faIconService: FaiconService,
    private uiService: UiService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
    this.initSub();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onEditFinished(action?: boolean): void {
    this.offerToEdit = null;
    this.isCreationMode = false;
    this.isSessionMode = false;
    this.isFileMode = false;
    this.offerPreview = this.offers[0];
    this.imageUpdate = null;

    if (action) this.getOffers();
  }

  onEdit(offer: FullOffer) {
    this.offerToEdit = offer;
    this.isCreationMode = true;
  }

  switchToSessionView(offer: FullOffer) {
    this.offerToEdit = offer;
    this.isCreationMode = false;
    this.isSessionMode = true;
  }

  switchToFilesView(offer: FullOffer) {
    this.offerToEdit = offer;
    this.isCreationMode = false;
    this.isSessionMode = false;
    this.isFileMode = true;
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  addOffer(): void {
    this.isCreationMode = true;
    this.offerPreview = null;
  }

  back(): void {
    const user = this.authService.getDecodedToken();

    if (user.role === 'club') {
      this.router.navigate(['/admin/my-club']);
    } else if (user.role === 'admin') {
      this.router.navigate(['/admin']);
    }
  }

  applyFilter(filterValue): void {
    this.dataService.valueInputSearchOfferAdminTable.next(filterValue);
  }

  resetSearch(): void {
    this.f.keyword.reset();
    this.dataService.valueInputSearchOfferAdminTable.next('');
  }


  openDialogOfferDetails(): void {
    // const dialogRef = this.dialog.open(OpendialogOfferDetailsComponent, {
    //   data: { offerSub: this.offer }
    // });

    // dialogRef.afterClosed().subscribe({
    //   next: () => this.tab = 'thumbnail'
    // });
  }


  getTooltip(value: string): string {
    return this.tooltip.getTooltip(value);
  }

  disabledToggle(): void {
    this.uiService.showSnackbar('Modification impossible: l\'offre est présente dans un panier ou a déjà été réservée');
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
  }

  get f() {
    return this.searchForm.controls;
  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });
  }

  private initSub(): void {

    this.subscription
      .add(
        this.dataService.valueInputSearchOfferAdminTable.subscribe({
          next: valueInput => {
            this.valueInput = valueInput;
            this.cdr.detectChanges();
          }
        })
      )

    this.isLoading = true;
    const { club_code: userClubCode } = this.authService.getDecodedToken();

    this.subscription
      .add(
        this.offerService.getFullOffer(userClubCode).subscribe({
          next: async offers => {
            this.offers = await offers.sort((a, b) => b.offerKey - a.offerKey);
            if (offers?.length) {
              this.offerPreview = this.offers[0];
              // this.offerKey = btoa(this.offers[0]?.offerKey.toString());

              // if (this.offerKey) {
              //   this.router.navigate([], {
              //     relativeTo: this.route,
              //     queryParams: { offerKey: this.offerKey },
              //     queryParamsHandling: 'merge',
              //   });
              // }
            }
            this.isLoading = false;
          }
        }))
  }

  changeOfferPreview(offerPreview: FullOffer) {
    this.offerPreview = offerPreview;
  }

  getOffers(): void {
    this.isLoading = true;
    const { club_code: userClubCode } = this.authService.getDecodedToken();

    this.offerService.getFullOffer(userClubCode).subscribe({
      next: async offers => {
        this.offers = await offers.sort((a, b) => b.offerKey - a.offerKey);
        this.offerPreview = this.offers[0];

        this.isLoading = false;
      }
    });
  }


}
